import * as React from "react"

import { GetApi } from "../../../../../api/api"
import AppContext from "../../../../../components/AppContext"
import Button from "../../../../../components/Button"

interface CsvImportProps {
  fccId: string
  atId: number
  refresh: () => void
  disabled: boolean
  setDisabled: (value: boolean) => void
  children: any
  className?: string
}

class CsvImport extends React.Component<CsvImportProps, {}> {
  public static contextType = AppContext
  private fileInput: any

  constructor(props: CsvImportProps) {
    super(props)
    this.fileInput = React.createRef()
  }

  public render() {
    return (
      <React.Fragment>
        <input
          type="file"
          accept=".csv, text/csv"
          id="allowedValueCsvUpload"
          ref={this.fileInput}
          disabled={this.props.disabled}
          style={{
            display: "none"
          }}
          onChange={this.onSelectFile}
        />
        <Button
          variant="secondary"
          onClick={this.onButtonClick}
          disabled={this.props.disabled}
          className={this.props.className}
        >
          {this.props.children}
        </Button>
      </React.Fragment>
    )
  }

  private onButtonClick = () => {
    this.fileInput.current.click()
  }

  private onSelectFile = async (e: any) => {
    this.props.setDisabled(true)
    const inputFile = e.target.files[0]
    e.target.value = null // In order to reset the input file field
    try {
      const api = await GetApi()
      await api.updateAttributeLegalValuesCSV(
        this.props.fccId,
        this.props.atId,
        inputFile
      )
      this.props.refresh()
    } catch (error) {
      this.context.useToasts.addToast(error, "danger")
    } finally {
      this.props.setDisabled(false)
    }
  }
}

export default CsvImport
